import axios from '@/libs/netAxios';

export class Client {
  get<TRequest, TResponse>(url: string, request: TRequest): Promise<TResponse> {
    return axios.request({
      method: 'GET',
      url,
      params: request
    })
  }
}